import React from "react";
import { Minus, Plus } from "lucide-react";

export default function QtyStepper({ qty, onDecrement, onIncrement, size = "md", label = "item" }) {
  const btn = size === "sm" ? "h-7 w-7" : "h-9 w-9";
  const icon = size === "sm" ? "h-3.5 w-3.5" : "h-4 w-4";
  return (
    <div className="inline-flex items-center rounded-lg border border-gray-200 bg-white">
      <button type="button" onClick={onDecrement} className={`${btn} flex items-center justify-center rounded-l-lg text-gray-600 hover:bg-gray-50`} aria-label={`Remove one ${label}`}>
        <Minus className={icon} />
      </button>
      <span className="min-w-[2rem] text-center text-sm font-semibold tabular-nums text-gray-900" aria-live="polite">{qty}</span>
      <button type="button" onClick={onIncrement} className={`${btn} flex items-center justify-center rounded-r-lg text-gray-600 hover:bg-gray-50`} aria-label={`Add one more ${label}`}>
        <Plus className={icon} />
      </button>
    </div>
  );
}
